import Main from './Main'
import Lista from './components/FormaPagamento'
import Novo from './components/NovaFormaPagamento'

export default [
  {
    path: 'pc-forma-pagamento',
    name: 'policiacivil.diarias.formapagamento',
    component: Main,
    redirect: { name: 'policiacivil.diarias.formapagamento.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.diarias.formapagamento.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.diarias.formapagamento.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.diarias.formapagamento.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/diarias/forma-pagamento/routes.js